<template>
	<base-focus-trap
		:disabled="!visible"
		:class="{
		'invisible': !visible
		}"
		id="vue-overlay-flickity"
		class="z-a1 fixed no-overscroll inset-0 transition-alpha overflow-auto flex items-center justify-center">

		<!-- Background mask,  -->
		<div class="inset-0 absolute bg-black-80 cursor-pointer z-0"></div>

		<!-- Modal will go into this...but there's no styling, do this on the modal container...unless you want a global style... -->

		<div v-if="loading" class="relative uppercase tracking-wide font-bold z-1 m-auto p-2 text-green">
			<div class="text-14 lds mr-2"><div></div><div></div><div></div></div>
			Loading...
		</div>
		<div :class="{
			'hidden': loading,
		}"
		class="relative z-1 m-auto w-full h-full flex items-center justify-center" ref="content">
			<div
				:style="boxStyle"
				class="carousel-box relative bg-black m-0 lg:m-9 flex-shrink-0">
        <template v-if="visible">
					<flickity-carousel
						:slides="slides"
						:sizes="slideSizes"
						@slide-size="onSlideSize"
						@aside-height="onAsideHeight">

					</flickity-carousel>
				</template>
				<button
						class="z-2 cursor-pointer group absolute bg-green transition-all-colors hover:bg-white p-4 top-0 right-0 no-mouse-focus"
						@click="dismiss">
					<svg class="text-white group-hover:text-green pointer-events-none fill-current w-4 h-4" xmlns="http://www.w3.org/2000/svg" width="14.2" height="14.2" viewBox="0 0 14.2 14.2"><path d="M9.2 7.1l4.5-4.5c.6-.6.6-1.5 0-2.1s-1.5-.6-2.1 0L7.1 5 2.6.4C2-.1 1-.1.4.4s-.6 1.5 0 2.1L5 7.1.5 11.6c-.6.6-.6 1.5 0 2.1.3.3.7.4 1.1.4s.8-.1 1.1-.4l4.5-4.5 4.5 4.5c.3.3.7.4 1.1.4s.8-.1 1.1-.4c.6-.6.6-1.5 0-2.1L9.2 7.1z"/></svg>
				</button>
			</div>
		</div>
	</base-focus-trap>
</template>
<script>

import FlickityCarousel from "@components/misc/flickity-carousel.vue";

const COLUMN_WIDTH = 232;       // lg:w-58, the caption column
const BOX_MARGIN = 72;          // lg:m-9, both sides; below lg the box runs edge to edge
const MAX_BOX_WIDTH = 2400;
const LG = 1024;                // the site's mobile/desktop split (mobileonly)
const DEFAULT_ASPECT = 1.5;

export default {
	components: {
		FlickityCarousel,
	},
	props:['visible','slides'],
	data() {
		return {
			myValue: "anand",
			slideAspect: null,
			slideHeight: null,
			asideHeight: 0,
			viewportWidth: window.innerWidth,
			viewportHeight: window.innerHeight,
		}
	},
	computed: {
		loading() {
			return false;
		},

		// The caption column is a fixed width beside the image, so the box has
		// to allow for it when sizing itself against the viewport.
		hasCaptionColumn() {
			const slides = this.slides || [];
			return slides.length > 1 || slides.some( slide => slide.caption || slide.photoCredit );
		},

		boxStyle() {
			const { width, height } = this.geometry( this.slideAspect, this.slideHeight );

			return {
				width: `${ width }px`,
				height: `${ height }px`,
			};
		},

		slideSizes() {
			return ( this.slides || [] ).map( slide => {
				const aspect = ( slide.width && slide.height ) ? slide.width / slide.height : null;
				return `${ this.geometry( aspect, slide.height ).imageWidth }px`;
			} );
		},
	},
	watch: {
		visible( newValue ) {
			if ( newValue ) {
				document.body.style.overflow = 'hidden';
			} else {
				document.body.style.overflow = 'visible';
				this.slideAspect = null;
				this.slideHeight = null;
				this.asideHeight = 0;
			}
		},
	},
	mounted() {
		window.VM = this;
		window.addEventListener('keydown', this.onClose );
		window.addEventListener('resize', this.onViewportResize );
	},
	beforeDestroy() {
		window.removeEventListener('keydown', this.onClose );
		window.removeEventListener('resize', this.onViewportResize );
	},
	methods: {
		// The one description of the box: a photo at its own aspect ratio, grown
		// until the viewport, the 2400px cap or the photo's own resolution stops
		// it, plus room for the caption — beside the image from lg up, beneath it
		// below that. Used both to size the box and to tell the browser how wide
		// the photo will be before it picks a srcset candidate.
		geometry( aspect, assetHeight ) {
			const ratio = aspect || DEFAULT_ASPECT;
			const stacked = this.viewportWidth < LG;
			const column = ( this.hasCaptionColumn && !stacked ) ? COLUMN_WIDTH : 0;
			const caption = stacked ? this.asideHeight : 0;
			const margin = stacked ? 0 : BOX_MARGIN;

			const imageHeight = Math.max( 1, Math.min(
				this.viewportHeight - margin - caption,
				assetHeight || Infinity,
				( this.viewportWidth - margin - column ) / ratio,
				( MAX_BOX_WIDTH - column ) / ratio
			) );

			// Floored so a rounded-up box can never overflow the viewport.
			const imageWidth = Math.floor( imageHeight * ratio );

			return {
				imageWidth,
				width: imageWidth + column,
				height: Math.floor( imageHeight ) + caption,
			};
		},

		onAsideHeight( height ) {
			this.asideHeight = height;
		},

		onViewportResize() {
			this.viewportWidth = window.innerWidth;
			this.viewportHeight = window.innerHeight;
		},

		onSlideSize( { aspect, height } ) {
			if ( aspect ) {
				this.slideAspect = aspect;
				this.slideHeight = height;
			}
		},

		onClose( e ) {
			if ( this.visible && e.key === 'Escape' ) {
				this.dismiss();
			}
		},

		dismiss() {
			this.$emit('dismiss');
		}
	}
}
</script>
<style lang="scss" scoped>
@use 'sass:math';

.transition-alpha {

	transition: opacity .3s ease;

	&.invisible {
		opacity: 0;
		transition: opacity .3s ease, visibility 0s linear .3s;
	}
}

.lds {
  display: inline-block;
  position: relative;
  vertical-align: middle;
  width: 1em;
  height: 1em;
}
.lds div {
  display: inline-block;
  position: absolute;
  left: math.div(6, 60) * 1em;
  width: math.div(13, 60) * 1em;
  background: currentColor;
  animation: lds 1.2s cubic-bezier(0, 0.5, 0.5, 1) infinite;
}
.lds div:nth-child(1) {
  left: math.div(6, 60) * 1em;
  animation-delay: -0.24s;
}
.lds div:nth-child(2) {
  left: math.div(26, 60) * 1em;
  animation-delay: -0.12s;
}
.lds div:nth-child(3) {
  left: math.div(45, 60) * 1em;
  animation-delay: 0;
}
@keyframes lds {
  0% {
    top: math.div(6, 60) * 1em;
    height: math.div(51, 60) * 1em;
  }
  50%, 100% {
    top: math.div(19, 60) * 1em;
    height: math.div(26, 60) * 1em;
  }
}
</style>
